var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{ref:"brtmap",class:_vm.$mapStep.type=='poiDetail' || _vm.$BRT.$options.PoiListDrawer == 3 ? 'brt-brtmap half':'brt-brtmap'})}
var staticRenderFns = []

export { render, staticRenderFns }